import type { ICartCRUDItem, ICartLiteApiService, ICartLiteEntityResponse } from '../../models';
import type { IProductEntity } from '@/entities';

import { _CartStore } from './Cart.abstract';
import { ProductMM } from '@/entities';

export class _CartStoreLite extends _CartStore<ICartLiteApiService, ICartLiteEntityResponse> {
  override handleResponse(cartResp: ICartLiteEntityResponse) {
    if (this.isResponseOutdated(cartResp)) return;

    this.products.value = cartResp.products.map((it) => new ProductMM(it));
    this.updatedAt.value = cartResp.updatedAt ?? Date.now();
    this.qnty.value = cartResp.totalGoodsCount;

    this.cartResponse.response = cartResp;
  }

  /** CRUDs */
  override async fetchCart(): Promise<any> {
    return this.APIService?.getCart().then((resp) => this.handleResponse(resp));
  }

  override async addProductToCart(product: IProductEntity, qnty = 1): Promise<any> {
    const amountInCart = this.getProductBySkuId(product.skuId)?.product?.amount ?? 0;
    qnty += amountInCart;

    return this.APIService?.updateCartItems([{ product, qnty }]).then((resp) =>
      this.handleResponse(resp)
    );
  }

  override async patchCart(data: ICartCRUDItem[]): Promise<any> {
    if (!data.length) return this.products.value;

    return this.APIService?.updateCartItems(data).then((resp) => this.handleResponse(resp));
  }

  public setResponse(response: ICartLiteEntityResponse) {
    this.handleResponse(response);
  }
}
